<template>
  <ValidateAll ref="header">
    <v-row v-if="!terkunci">
      <v-col cols="6">
        <div class="headline mt-2">{{title()}}</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="primary"
          large
          @click="save"
          :loading="saving"
          :disabled="isProgramEmpty || details.length == 0 || isKegiatanEmpty || isTanggalPelaporanEmpty || isSekolahEmpty"
        >
          <span class="hidden-xs-only">Simpan</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-content-save-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row :dense="$vuetify.breakpoint.xsOnly">
      <!-- Header -->
      <v-col cols="12" md="3">
        <v-card class="card-summary card-summary--sp2b">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-bag-personal</v-icon>Sekolah
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isSekolahEmpty || isEditingSekolah) && !terkunci && !saving && !$acl.check('isSekolah')"
              @click="isEditingSekolah = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Sekolah"
                rules="fully_required"
                #default="{ errors }"
                v-if="isEditingSekolah"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.Sekolah"
                  :loading="list.isSekolahLoading"
                  :items="list.sekolah.data"
                  name="Sekolah"
                  placeholder="Pilih Sekolah"
                  item-text="Nama"
                  item-value="IDSekolah"
                  dense
                  hide-no-data
                  return-object
                  @input="sekolahChange"
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isSekolahEmpty"
                      :color="isSekolahEmpty ? 'disabled' : 'success'"
                      @click="isEditingSekolah = !isEditingSekolah"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <!-- selected slot -->
                  <template v-slot:selection="data">
                    <v-list-item-title>
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </v-list-item-title>
                  </template>
                  <!-- list item slot -->
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title class="py-0">
                          {{data.item.Nama}}
                          &mdash;
                          <span
                            class="text--secondary"
                          >{{data.item.Kode}}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.Alamat}} {{ data.item.Lokasi}} {{data.item.Provinsi}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isSekolahEmpty && !isEditingSekolah">
                <v-list-item-title class="title">{{header.Sekolah.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.Sekolah.Kode}}</span>
                  &mdash;
                  {{header.Sekolah.Alamat}} {{header.Sekolah.Lokasi}} {{header.Sekolah.Provinsi}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="card-summary card-summary--sp2b">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-run</v-icon>Kegiatan
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isKegiatanEmpty || isEditingKegiatan || isEdit) && !terkunci && !saving"
              @click="isEditingKegiatan = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item v-if="isEditingKegiatan">
              <v-autocomplete
                class="mb-1 mt-1"
                v-model="header.Program"
                :loading="list.isProgramLoading"
                :items="list.program.data"
                name="Program"
                :placeholder="isSekolahEmpty? 'Pilih Sekolah Terlebih Dahulu':'Pencarian Program'"
                :disabled="isSekolahEmpty"
                item-text="Nama"
                item-value="IDProgram"
                dense
                hide-details
                hide-no-data
                return-object
                @input="programChange"
              >
                <!-- selected slot -->
                <template v-slot:selection="data">
                  <v-list-item-title>
                    {{data.item.Nama}}
                    &mdash;
                    <span
                      class="text--secondary"
                    >{{data.item.Kode}}</span>
                  </v-list-item-title>
                </template>
                <!-- list item slot -->
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-list-item>
            <v-list-item :class="{'mt-n2':isEditingKegiatan}">
              <v-autocomplete
                v-if="isEditingKegiatan"
                class="mb-1 mt-1"
                v-model="header.Kegiatan"
                :loading="list.isKegiatanLoading"
                :items="listKegiatan"
                name="Kegiatan"
                :placeholder="isProgramEmpty? 'Pilih Program Terlebih Dahulu':'Pencarian Kegiatan'"
                :disabled="isProgramEmpty"
                item-text="Nama"
                item-value="IDKegiatan"
                dense
                hide-details
                hide-no-data
                return-object
                @input="kegiatanChange"
              >
                <!-- button slot -->
                <template v-slot:append-outer>
                  <v-btn
                    icon
                    :disabled="isKegiatanEmpty"
                    :color="isKegiatanEmpty ? 'disabled' : 'success'"
                    @click="isEditingKegiatan = !isEditingKegiatan"
                  >
                    <v-icon>mdi-check-outline</v-icon>
                  </v-btn>
                </template>
                <!-- selected slot -->
                <template v-slot:selection="data">
                  <v-list-item-title>
                    {{data.item.Nama}}
                    &mdash;
                    <span
                      class="text--secondary"
                    >{{data.item.Kode}}</span>
                  </v-list-item-title>
                </template>
                <!-- list item slot -->
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-list-item-content v-if="!isKegiatanEmpty && !isEditingKegiatan">
                <v-list-item-title class="title">{{header.Kegiatan.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.Kegiatan.Kode}}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card class="card-summary card-summary--sp2b">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-wallet</v-icon>Saldo Awal
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item
              two-line
              @click="isEditingSaldoAwal = (isSaldoAwalEnable ? true:false)"
              v-if="!isEditingSaldoAwal"
            >
              <v-list-item-content>
                <v-list-item-title class="title">{{header.NominalSaldoAwal | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDateBelanja">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDateBelanja | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line v-if="isEditingSaldoAwal">
              <v-text-field
                class="mb-1 mt-1"
                v-model.number="header.NominalSaldoAwal"
                name="SaldoAwal"
                type="number"
                placeholder="0"
                large
                hide-no-data
                :disabled="!isSaldoAwalEnable"
                @blur="isEditingSaldoAwal = false"
              ></v-text-field>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card class="card-summary card-summary--sp2b">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-cart</v-icon>Saldo Akhir
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="title">{{totalSaldoAkhir | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDateBelanja">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDateBelanja | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-subtitle class="pb-0">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-calendar-check-outline</v-icon>Transaksi
            </div>
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader :loading="loading" type="list-item-two-line,list-item-two-line">
                  <v-text-field
                    name="Nomor"
                    label="Nomor"
                    placeholder="Nomor akan muncul setelah transaksi disimpan"
                    v-model="header.Nomor"
                    hide-details="auto"
                    disabled
                  ></v-text-field>

                  <br />

                  <v-dialog
                    ref="dialog"
                    v-model="modalDatepicker"
                    :return-value.sync="header.TanggalPelaporan"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formattedDate"
                        label="Bulan Pelaporan"
                        readonly
                        :loading="checkingSP2BMonth"
                        v-bind="attrs"
                        v-on="!isSekolahEmpty && !isKegiatanEmpty?on:false"
                        :disabled="terkunci || saving || isSekolahEmpty || isKegiatanEmpty ||checkingSP2BMonth || !isTanggalPelaporanEnable"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="header.TanggalPelaporan"
                      scrollable
                      type="month"
                      :allowed-dates="allowedMonths"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalDatepicker = false">Batal</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(header.TanggalPelaporan)"
                      >Pilih</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-skeleton-loader>
              </v-col>
              <v-divider vertical class="hidden-xs-only" />
              <v-col class="mr-n1 mt-6 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0" cols="12" md="6">
                <v-skeleton-loader :loading="loading" type="list-item-three-line">
                  <v-textarea
                    no-resize
                    :height="$vuetify.breakpoint.xsOnly ? '20px':'102px'"
                    :rows="$vuetify.breakpoint.xsOnly ? 3:5"
                    name="Keterangan"
                    label="Keterangan"
                    placeholder="Keterangan"
                    v-model="header.Keterangan"
                    hide-details="auto"
                    :readonly="terkunci || saving"
                  ></v-textarea>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Details -->
      <v-col cols="12">
        <v-card>
          <v-card-subtitle class="pb-0">
            <div class="overline">
              <v-icon small left>mdi mdi-table</v-icon>Rincian
            </div>
          </v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader :loading="loading" type="table">
              <rincian-sp2b
                v-model="details"
                @update-details="updateDetails"
                :disabled="terkunci || isSekolahEmpty || saving || isKegiatanEmpty"
                :IDSekolah="header.IDSekolah"
                :Tanggal="header.TanggalPelaporan"
                :IDKegiatan="header.IDKegiatan"
              ></rincian-sp2b>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </ValidateAll>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    RincianSp2b: () =>
      import(
        /* webpackChunkName: "RincianSp2b" */ "@/components/RincianSp2b.vue"
      )
  },
  data: () => ({
    saving: false,
    loading: false,
    header: {
      Nomor: "",
      Tahun: 0,
      TanggalPelaporan: "",
      Keterangan: "",
      IDSekolah: "",
      Sekolah: {},
      IDKegiatan: "",
      Kegiatan: {},
      IDProgram: "",
      Program: {},
      IDBidang: "",
      Bidang: {},
      IDUrusan: "",
      Urusan: {},
      IDPejabatDaerah: "",
      PejabatDaerah: {},
      NominalSaldoAwal: 0,
      NominalPenerimaan: 0,
      NominalBelanja: 0
    },
    details: [],
    pajak: [],
    bulan: [],
    modalDatepicker: false,
    isEditingSekolah: false,
    isEditingPejabat: false,
    isEditingKegiatan: false,
    isEditingProgram: false,
    isEditingSaldoAwal: false,
    isSaldoAwalEnable: false,
    checkingSP2BMonth: false,
    isTanggalPelaporanEnable: true,
    isEdit: false,
    Keyword: ""
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isSekolahLoading",
      "isKegiatanLoading",
      "isRekeningLoading",
      "isPejabatLoading",
      "isKegiatanLoading",
      "isProgramLoading"
    ]),
    isTanggalPelaporanEmpty() {
      return !this.header.TanggalPelaporan;
    },
    isKegiatanEmpty() {
      return this.$util.isEmpty(this.header.Kegiatan);
    },
    isProgramEmpty() {
      return this.$util.isEmpty(this.header.Program);
    },
    isSekolahEmpty() {
      return this.$util.isEmpty(this.header.Sekolah);
    },
    lastUpdatedDatePenerimaan() {
      return this.getLastUpdatedDate("penerimaan");
    },
    lastUpdatedDateBelanja() {
      return this.getLastUpdatedDate("belanja");
    },
    listKegiatan() {
      if (!this.isProgramEmpty) {
        return this.list.kegiatan.data.filter(
          x => x.IDProgram == this.header.IDProgram
        );
      }
      return [];
    },
    totalPajak() {
      return 0;
    },
    terkunci() {
      return this.header && !!this.header.ETLID;
    },
    formattedDate() {
      let tanggal = this.header.TanggalPelaporan;
      if (!tanggal) {
        if (this.checkingSP2BMonth) {
          return "Mengecek data SP2B ...";
        }
        if (this.isSekolahEmpty || this.isKegiatanEmpty) {
          return "Pilih sekolah dan kegiatan terlebih dahulu";
        }
        return "Pilih bulan pelaporan";
      } else {
        tanggal = new Date(tanggal);
      }

      return this.$format.dateMonth(
        new Date(tanggal.getFullYear(), tanggal.getMonth() + 1, 0)
      );
    },
    totalSaldoAkhir() {
      return (
        this.header.NominalSaldoAwal +
        this.header.NominalPenerimaan -
        this.header.NominalBelanja
      );
    }
  },
  methods: {
    ...mapActions("list", [
      "refreshCurrentProgramKegiatan",
      "refreshSekolah",
      "refreshPajak",
      "refreshPejabat"
    ]),
    async save() {
      let param = { ...this.header };
      param.TanggalPelaporan = new Date(param.TanggalPelaporan);
      param.RingkasanTransaksi = this.details;

      const valid = await this.$refs.header.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/report/sp2b", param)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/laporan/sp2b");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    allowedMonths(v) {
      return this.bulan.indexOf(v.substring(0, 7)) < 0;
    },
    checkExistSP2BMonth(param) {
      this.checkingSP2BMonth = true;
      this.$axios
        .post(`/report/sp2b/check_exist`, param)
        .then(res => {
          let data = res.data.Data;
          var rawBulan = data.map(d => d.TanggalPelaporan);
          for (var i = 0; i < rawBulan.length; i++) {
            var bulan = rawBulan[i].substring(0, 7);
            this.bulan.push(bulan);
          }
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.isSaldoAwalEnable = false;
          this.checkingSP2BMonth = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah SP2B" : "SP2B Baru";
    },
    getLastUpdatedDate(jenis = "belanja") {
      if (this.details.length == 0) return;

      let result = this.details.filter(x => x.Jenis == jenis);
      if (!result) return;

      result = result.sort((a, b) => {
        let paramA = a.LastUpdatedDate || a.CreatedDate;
        let paramB = b.LastUpdatedDate || b.CreatedDate;

        if (paramA > paramB) return 1;
        return -1;
      })[0];

      if (!result) return;

      return result.LastUpdatedDate || result.CreatedDate;
    },
    getSummary() {
      this.header.NominalBelanja = _.sumBy(
        this.details.filter(x => x.Jenis == "belanja"),
        x => x.Total
      );
      this.header.NominalPenerimaan = _.sumBy(
        this.details.filter(x => x.Jenis == "penerimaan"),
        x => x.Total
      );
    },
    updateDetails(data) {
      this.details = data;
    },
    checkEditingStatus() {
      this.isEditingSekolah = this.isSekolahEmpty;
      this.isEditingKegiatan = this.isKegiatanEmpty;
    },
    checkSaldoAwal() {
      // let id = this.$route.params.id;
      if (
        this.isTanggalPelaporanEmpty ||
        this.isKegiatanEmpty ||
        this.isSekolahEmpty
      ) {
        this.header.NominalSaldoAwal = this.header.NominalSaldoAwal || 0;
        return;
      }

      var param = {
        Bulan: new Date(this.header.TanggalPelaporan),
        IDSekolah: this.header.IDSekolah,
        IDKegiatan: this.header.IDKegiatan
      };
      this.$axios
        .post(`/report/sp2b/saldo_awal`, param)
        .then(res => {
          let data = res.data.Data;
          this.header.NominalSaldoAwal = data.SaldoAwal;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          if (this.header.NominalSaldoAwal <= 0) {
            this.isEditingSaldoAwal = true;
            this.isSaldoAwalEnable = true;
          }
        });
    },
    sekolahChange() {
      this.header.Program = null;
      this.header.Kegiatan = null;
      this.header.IDKegiatan = "";
      this.header.TanggalPelaporan = "";
      this.details = [];
      this.checkSaldoAwal();
    },
    programChange() {
      this.header.Kegiatan = null;
      this.header.IDKegiatan = "";
      this.header.TanggalPelaporan = "";
      this.details = [];
      this.checkSaldoAwal();
    },
    kegiatanChange() {
      this.header.TanggalPelaporan = "";
      this.details = [];
      this.checkSaldoAwal();
    }
  },
  created() {
    this.isEdit = !!this.$route.params.id;
  },
  async mounted() {
    this.refreshPajak();

    let id = this.$route.params.id;
    let user = this.$session.get.user();
    let isUserSekolah = this.$acl.check("isSekolah") && !!user.idSekolah;
    if (!isUserSekolah) this.refreshSekolah();
    if (id) {
      this.isTanggalPelaporanEnable = false;
      this.loading = true;
      this.$axios
        .get(`/report/sp2b/${id}`)
        .then(res => {
          let result = res.data.Data;

          result.TanggalPelaporan = new Date(result.TanggalPelaporan)
            .toISOString()
            .substr(0, 10);

          let rt = result.RingkasanTransaksi || [];
          rt.forEach(d => {
            this.details.push(d);
          });

          this.header = result;
          this.loading = false;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.checkEditingStatus();
        });
    } else {
      this.isTanggalPelaporanEnable = true;
      this.loading = true;
      this.$axios
        .post(`/administration/status_anggaran/current`, {})
        .then(async res => {
          let data = res.data.Data;
          this.header.Tahun = data.Tahun;
          this.header.StatusAnggaran = data.StatusAnggaran;

          // checking editing status
          this.isEditingTahun = this.isTahunEmpty;
          this.isEditingStatusAnggaran = this.isStatusAnggaranEmpty;

          // if logged user is user sekolah
          // then assign its user as default
          if (user.idSekolah) {
            this.loading = true;
            let filter = new this.$dbflex();
            filter.eq("IDSekolah", user.idSekolah);
            this.$axios
              .post(`/administration/sekolah/list`, { Filter: filter.get() })
              .then(res => {
                let data = res.data.Data;
                if (data && data.length > 0) {
                  this.header.IDSekolah = user.idSekolah;
                  this.header.Sekolah = data[0];
                }
              })
              .finally(() => {
                this.loading = false;
                this.checkEditingStatus();
              });
          } else {
            this.checkEditingStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    "header.Sekolah"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDSekolah = v.IDSekolah;
        this.refreshCurrentProgramKegiatan({ IDSekolah: v.IDSekolah });
      } else this.header.IDSekolah = "";
    },
    "header.Program"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDProgram = v.IDProgram;
      } else {
        this.header.IDProgram = "";
      }
    },
    "header.Kegiatan"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDKegiatan = v.IDKegiatan;
        this.header.IDBidang = v.IDBidang;
        this.header.IDUrusan = v.IDUrusan;
      } else {
        this.header.IDKegiatan = "";
        this.header.IDBidang = "";
        this.header.IDUrusan = "";
        this.header.TanggalPelaporan = "";
      }
      this.checkExistSP2BMonth({
        IDSekolah: this.header.IDSekolah,
        Tahun: this.header.Tahun,
        IDKegiatan: this.header.IDKegiatan
      });
      this.bulan = [];
      this.NominalSaldoAwal = 0;
      this.NominalPenerimaan = 0;
      this.NominalBelanja = 0;
    },
    "header.TanggalPelaporan"(v) {
      let id = this.$route.params.id;
      if (!id) {
        if (v.substr(5, 2) == "01") {
          this.isEditingSaldoAwal = true;
          this.isSaldoAwalEnable = true;
        } else {
          this.isEditingSaldoAwal = false;
          this.isSaldoAwalEnable = false;
          this.checkSaldoAwal();
        }
      }
    },
    "list.sekolah.data"(v) {
      var user = this.$session.get.user();
      if (!this.$util.isEmpty(v) && user.idSekolah)
        this.header.Sekolah = v.find(s => s.IDSekolah == user.idSekolah);
    },
    details(v) {
      if (v.length > 0) {
        this.getSummary();
        this.checkEditingStatus();
      }
    }
  }
};
</script>

<style>
.card-summary.card-summary--sp2b {
  height: 120px !important;
}
</style>